import fr from 'date-fns/locale/fr';
import formatLong from './_lib/formatLong/index.esm.js';

var locale = {
  code: 'fr',
  formatDistance: fr.formatDistance,
  formatLong: formatLong,
  formatRelative: fr.formatRelative,
  localize: fr.localize,
  match: fr.match,
  options: fr.options
};

export default locale;
//# sourceMappingURL=index.esm.js.map
